import { DraftReturnSchema } from "@redotech/redo-model/draft-return/draft-return";
import * as z from "zod/v4";

export const selectReturnItems = {
  name: "selectReturnItems" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnItemIds: z.string().array(),
    bundleTogetherState: z.record(z.string(), z.boolean()).nullish(),
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
